import React from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useTranslator } from '@jutro/locale';
import { MLLOBDisplayService } from 'gw-capability-gateway';
import MLPolicySummaryDetailsComponent from '../MLPolicySummaryDetailsComponent/MLPolicySummaryDetailsComponent';
import MLLegacyPolicySummaryDetailsComponent from '../MLLegacyPolicySummaryDetailsComponent/MLLegacyPolicySummaryDetailsComponent';

import metadata from './MLPolicySummaryComponent.metadata.json5';
import messages from './MLPolicySummaryComponent.messages'

const MLPolicySummaryComponent = (props) => {
    const { policySummaries, legacyPolicies } = props;

    const translator = useTranslator();

    const sortedPolicySummaries = policySummaries.sort((a, b) => {
        return MLLOBDisplayService.getLOBSortIndex(a) - MLLOBDisplayService.getLOBSortIndex(b);
    });
    const bundledPolicies = sortedPolicySummaries.filter((policy) => policy.bundleID_ML === 1);
    const singlePolicies = sortedPolicySummaries.filter((policy) => policy.bundleID_ML === 0);
    const hasLegacyPolicies = legacyPolicies.length > 0;

    const overrideProps = {
        bundledPoliciesContainer: {
            visible: !_.isEmpty(bundledPolicies)
        },
        bundledPolicies: {
            policies: bundledPolicies,
            isBundled: true
        },
        singlePoliciesContainer: {
            visible: !_.isEmpty(singlePolicies)
        },
        singlePolicies: {
            policies: singlePolicies
        },
        legacyPoliciesContainer: {
            visible: hasLegacyPolicies
        },
        legacyPolicies: {
            policies: legacyPolicies,
            isArs: hasLegacyPolicies
        },
        noPoliciesContainer: {
            visible: _.isEmpty(policySummaries) && _.isEmpty(legacyPolicies) 
        },
        noPoliciesText: {
            content: translator(messages.noPolicies)
        }
    }

    const resolvers = {
        resolveComponentMap: {
            MLPolicySummaryDetailsComponent,
            MLLegacyPolicySummaryDetailsComponent
        }
    };

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            overrideProps={overrideProps}
            componentMap={resolvers.resolveComponentMap}
        />    
    )
};

MLPolicySummaryComponent.propTypes = {
    policySummaries: PropTypes.arrayOf(PropTypes.shape({})),
    legacyPolicies: PropTypes.arrayOf(PropTypes.shape({}))
};

MLPolicySummaryComponent.defaultProps = {
    policySummaries: [],
    legacyPolicies: []
};

export default MLPolicySummaryComponent;